import { Title } from "../shared/title/title.tsx";
import JSZip from "jszip";
import shots from "../media/shots.json";

function Assets() {
    const downloadsFolder = process.env.PUBLIC_URL + '/assets/downloadable/';

    const handleDownloadClick = async () => {
        const zip = new JSZip();
        const folder : JSZip | null = zip.folder("hold_me_tight_assets");
        if (folder) {
            folder.file("logo_black_lettering.png", await fetch(downloadsFolder+ 'HMT-letteringonly.png').then(res => res.blob()));
            folder.file("logo_white.png", await fetch(downloadsFolder+ 'HMT_light_logo.jpeg').then(res => res.blob()));
            folder.file("logo_black.png", await fetch(downloadsFolder+ 'HMT_dark_logo.png').then(res => res.blob()));
            folder.file("HMT_vertical.jpg", await fetch(downloadsFolder + 'DSCF5204.jpg').then(res => res.blob()));
            folder.file("HMT_horizontal.jpg", await fetch(downloadsFolder + 'HMT2026-TessaWiegerinck_DSF5323-web.jpg').then(res => res.blob()));
           
        }
        const content = await zip.generateAsync({ type: "blob" });
        const url = URL.createObjectURL(content);
        const a = document.createElement("a");
        a.href = url;
        a.download = "hold_me_tight_assets.zip";
        a.click();
        URL.revokeObjectURL(url);
    };

    return <div id='assets' className="animated">
        <Title value="Press Photos & Logo" />
        <div id='assets-container' style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", "cursor": "pointer"}}>
            <p onClick={handleDownloadClick}>Download assets</p>
        </div>
    </div>
}

export { Assets }  